/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file in progress apps store updater methods
 * @module Epic.AppOrchard.StoreMethods.InProgressApps
 */

import { IDispatch } from "@epic/react-redux-booster";
import { InstallStatus } from "ao/data";
import { inProgressAppsActions } from "ao/state/widgets/inProgressApps";
import { IInProgressApp } from "ao/types";

/**
 * Update store with in progress apps after loading from server
 * @param dispatch for useDispatch
 * @param orgId customer org id
 * @param apps in progress apps for customer org
 */
export function updateAppsAfterLoad(dispatch: IDispatch, orgId: number, apps: IInProgressApp[]) {
	dispatch(inProgressAppsActions.updateAppsAfterLoad({ orgId, apps }));
}

/**
 * Update an app's install status
 * @param dispatch for useDispatch
 * @param appId client app id
 * @param orgId customer org id
 * @param newStatus new install status
 */
export function updateInstallStatusInStore(
	dispatch: IDispatch,
	appId: number,
	orgId: number,
	newStatus: InstallStatus,
) {
	dispatch(inProgressAppsActions.updateInstallStatus({ appId, orgId, newStatus }));
}

/**
 * Add a newly requested app to the store
 * @param dispatch for useDispatch
 * @param orgId customer org id
 * @param app the app the was requested
 */
export function addRequestedApp(dispatch: IDispatch, orgId: number, app: IInProgressApp) {
	dispatch(inProgressAppsActions.addRequestedApp({ orgId, app }));
}
